import * as React from "react";

const SvgMeditation = (props) => (
  <svg
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M250 502c138.623 0 251-112.377 251-251S388.623 0 250 0-1 112.377-1 251s112.377 251 251 251Z"
      fill="url(#meditation_svg__a)"
      id="outer-sun"
      
      />
    <path
      d="M250 456c113.218 0 205-91.782 205-205S363.218 46 250 46 45 137.782 45 251s91.782 205 205 205Z"
      fill="url(#meditation_svg__b)"
      id="inner-sun"
      
      />
    <path
      id="terrain"
      d="m32 501 16.568-29.078 13.507-3.933 24.643-12.698 11.127-22.211 12.713-8.703 10.334-3.969 10.324-11.106 7.953-10.313s2.38-5.553 10.333-8.703c7.953-3.151 7.15-.792 15.094-7.137 7.944-6.344 8.72-9.521 12.723-12.698 4.002-3.177 17.579-11.105 17.579-11.105l7.752-7.981 9.636-4.004h32.578l11.563-3.96 8.31.792s5.467-4.203 9.539 3.168c4.073 7.372 10.464 7.459 10.464 7.459h14.162s.793-1.906 5.563 6.031l4.77 7.929s-1.596 3.177 3.968 10.313c5.563 7.137 11.126 8.704 15.103 10.314a51.683 51.683 0 0 0 7.944 2.376s3.976 8.703 6.365 9.521c2.389.818 11.153-4.734 11.153-4.734l8.72-2.376 3.976-.801s3.174-3.96 5.564 3.969l2.38 7.937c.561 3.941.826 7.917.794 11.897 0 7.137-2.381 6.345 0 10.305 2.38 3.96 5.598 10.313 5.598 10.313l7.15 10.314 6.366 7.928 13.516 1.593 15.897 4.761s7.15 7.928 11.92 11.096 13.507 10.314 13.507 10.314L468 495.717V501H32Z"
      fill="#907373"
    />
    <path id="monk"
      d="M311.631 314.276c-4.205-.253-8.705-.41-13.102-.872-2.063-.209-4.666-.331-5.998-1.578-8.209-7.7-17.14-15.042-17.654-27.722-.157-3.775-.662-7.525-.81-11.336-.478-11.973-2.481-14.658-13.763-18.12-7.983-2.442-9.889-5.041-9.219-13.211.157-1.962.636-4.299 1.846-5.695 3.995-4.578 2.533-9.836 2.133-14.824-.566-6.828-3.796-9.592-10.447-9.897-6.094-.306-10.159 2.781-11.587 8.894a32.181 32.181 0 0 0-1.001 6.418 23.172 23.172 0 0 0 .618 6.898c.984 3.488 3.073 6.784 3.595 10.325.793 5.389-2.202 9.217-7.399 10.778-1.524.453-3.108.689-4.666 1.029-7.191 1.561-10.02 4.543-10.447 11.789-.452 7.386-.304 14.825-.914 22.185-.278 3.339-.87 7.325-2.855 9.714-3.386 4.055-7.835 7.299-12.188 10.421-1.741 1.22-4.274 1.482-6.494 1.691-3.134.288-6.32 0-9.471.192-2.011.131-4.623-.279-4.71 3.078-.078 3.183-.809 6.811 3.334 7.918 2.838.759 5.894.68 8.209.916.601 2.232.619 5.092 1.994 6.924 3.63 4.831 7.835 9.208 11.831 13.778.87.967 2.611 2.45 2.376 2.851-2.019 3.715 1.445 5.912 2.333 8.72.322 1.029 2.42 2.215 3.63 2.137 6.207-.393 12.379-1.675 18.56-1.675 5.267 0 10.029-3.723 15.574-1.325 12.118 5.232 25.246 2.11 37.799 4.238 3.665.628 7.269-2.302 8.087-6.104.662-3.061 2.403-6.75-3.151-7.691 6.381-5.52 14.085-9.723 11.787-19.795 8.879 1.997 16.81 1.194 12.17-11.049Zm-92.965 11.685-19.212-8.615c9.924-5.04 23.13-6.488 23.965-22.062 2.995 9.391 2.377 13.22-4.753 30.677Zm47.697 1.422c-4.596-13.081-8.592-26.37-2.02-40.113 2.499 6.435.636 15.095 7.226 20.222 5.78 4.508 12.039 8.406 17.585 12.208l-22.791 7.683Z"
      fill="#907373"
    />
    <defs>
      <linearGradient
        id="meditation_svg__a"
        x1={250}
        y1={0}
        x2={250}
        y2={502}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1EDCD" />
        <stop offset={1} stopColor="#EE8288" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="meditation_svg__b"
        x1={250}
        y1={46}
        x2={250}
        y2={456}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE8288" />
        <stop offset={1} stopColor="#EE8288" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgMeditation;
